export default "<r-application-terms-and-conditions #applicationTermsRef></r-application-terms-and-conditions>\n";